{
	"type": "symbol",
	"minzoom": 8,
	"layout": {
		"icon-image": [
			"match",
			["get", "control_category"],
			"Flashing Lights",
			"rlgsp:levelcrossings_passive",
			"Boom Gates & Flashing Lights",
			"rlgsp:levelcrossings_boomgates_flashinglights",
			"rlgsp:levelcrossings_boomgates"
		],
		"icon-size": 1,
		"icon-overlap": "cooperative"
	},
	"paint": {}
}
